import { render, staticRenderFns } from "./Echarts4.vue?vue&type=template&id=501b876c&scoped=true&"
import script from "./Echarts4.vue?vue&type=script&lang=js&"
export * from "./Echarts4.vue?vue&type=script&lang=js&"
import style0 from "./Echarts4.vue?vue&type=style&index=0&id=501b876c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b876c",
  null
  
)

export default component.exports